import { createContext } from '@chakra-ui/react-utils';
import { ReactNode } from 'react';
import { getReturnType } from 'src/features/BestOfRing/utils';
import { useGetBestOfRingContextValue } from './hooks';

const BestOfRingContextValue = getReturnType(useGetBestOfRingContextValue);

export type BestOfRingContextValueType =
  typeof BestOfRingContextValue.returnType;

export const [BestOfRingContextProvider, useBestOfRingContext] =
  createContext<BestOfRingContextValueType>({
    name: 'BestOfRingContext',
  });

export type BestOfRingProviderProps = {
  children: ReactNode;
};

export const BestOfRingProvider = ({ children }: BestOfRingProviderProps) => {
  const { gallery, getVideoCollectionById, videoList, loading } =
    useGetBestOfRingContextValue();

  return (
    <BestOfRingContextProvider
      value={{ gallery, getVideoCollectionById, videoList, loading }}
    >
      {children}
    </BestOfRingContextProvider>
  );
};
